import { FaCalendarDays, FaMicrophoneLines, FaUsersViewfinder, FaClipboardList } from "react-icons/fa6";
import images from "./images";

const About = {
    sub: "About Eventia",
    heading: "Empowering Connections Through Premier Events",
    description: "Eventia is your go-to platform for hosting impactful conferences, business summits, and professional gatherings. We create immersive experiences that connect industry leaders, inspire innovation, and foster meaningful networking.",
    points: [
        { icon: <FaCalendarDays />, title: "Curated Events" },
        { icon: <FaMicrophoneLines />, title: "Keynote Speakers" },
        { icon: <FaUsersViewfinder />, title: "Professional Networking" },
        { icon: <FaClipboardList />, title: "Resource Access" }
    ],
    image: {
        src1: images.about1,
        src2: images.about2,
        src3: images.about3,
        src4: images.about4,
        alt1: "Conference Networking",
        alt2: "Speaker Session",
        alt3: "Attendee Interaction",
        alt4: "Event Resources"
    },
    button: {
        text: "Join Us",
        link: "Registration"
    }
};

export default About;